// src/vatandas/VatandasApp.js

import React from "react";
import { Routes, Route } from "react-router-dom";
import VatandasLayout from "./components/VatandasLayout";
import ScrollToTop from "./components/ScrollToTop";

// Sayfalar
import VatandasHomePage from "./pages/VatandasHomePage";
import VatandasApplicationTrackingPage from "./pages/VatandasApplicationTrackingPage";
import VatandasCreateApplicationPage from "./pages/VatandasCreateApplicationPage";

import VatandasSurveyPage from "./pages/VatandasSurveyPage";
import VatandasLoginPage from "./pages/VatandasLoginPage";
import VatandasKentHaritasi from "./pages/VatandasKentHaritasi";
// FAZ-63 — SMS kısa linki: {ana}/g/<kod> → çözüm → (giriş) → hedef sayfa
import KisaLinkPage from "./pages/KisaLinkPage";


function VatandasApp() {
  return (
    <VatandasLayout>
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<VatandasHomePage />} />
        <Route path="/giris" element={<VatandasLoginPage />} />
        <Route path="/memnuniyet-anketi" element={<VatandasSurveyPage />} />
        <Route path="/kent-haritasi" element={<VatandasKentHaritasi />} />
        
        <Route path="/basvuru-yap" element={<VatandasCreateApplicationPage />} />
        <Route path="/basvuru-takip" element={<VatandasApplicationTrackingPage />} />

        {/* FAZ-63 — kısa link. Yol bilinçli olarak KISA ("/g/"): adres SMS'te
            geçiyor ve her karakter sayılıyor. */}
        <Route path="/g/:code" element={<KisaLinkPage />} />

      </Routes>
    </VatandasLayout>
  );
}

export default VatandasApp;
